import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["id", "children"];
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context4; _forEachInstanceProperty(_context4 = ownKeys(Object(source), true)).call(_context4, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context5; _forEachInstanceProperty(_context5 = ownKeys(Object(source))).call(_context5, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable max-lines */
import React, { useRef, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { v4 as uuid } from 'uuid';
import mergeRefs from 'react-merge-refs';
import maxSize from 'popper-max-size-modifier';
import Box from '@rexlabs/box';
import { useToken, useStyles, StyleSheet, border } from '@rexlabs/styling';
import { Breakpoints } from '@rexlabs/breakpoints';
import { Tether } from '@rexlabs/tether';
import { TransitionSingle } from '@rexlabs/animation';
import { SimpleToggleButton } from './components/buttons/simple';
import { SelectOverlay } from './components/overlay';
import { Menu } from './components/menu';
import { SimpleOption } from './components/options/simple';
import { SelectProvider } from './context';
import { useSelect } from './hooks/use-select';
var defaultStyles = StyleSheet({
  popper: _objectSpread(_objectSpread({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  }, border.styles({
    target: 'select.menu',
    all: {
      width: 'thin',
      radius: 'm',
      color: 'input.active'
    }
  })), {}, {
    backgroundColor: function backgroundColor(_ref) {
      var token = _ref.token;
      return token('select.menu.background.color', token('color.container.static.default'));
    }
  })
});
var DEFAULT_MAX_HEIGHT = 10000;
export function SelectInner(_ref2) {
  var _referenceEl$current$, _referenceEl$current;

  var _ref2$searchable = _ref2.searchable,
      searchable = _ref2$searchable === void 0 ? true : _ref2$searchable,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      helperText = _ref2.helperText,
      _ref2$placeholder = _ref2.placeholder,
      placeholder = _ref2$placeholder === void 0 ? searchable ? 'Type to search' : 'Select item' : _ref2$placeholder,
      _ref2$portalTarget = _ref2.portalTarget,
      portalTarget = _ref2$portalTarget === void 0 ? window.document.body : _ref2$portalTarget,
      meta = _ref2.meta,
      _ref2$Option = _ref2.Option,
      Option = _ref2$Option === void 0 ? SimpleOption : _ref2$Option,
      _ref2$ToggleButton = _ref2.ToggleButton,
      ToggleButton = _ref2$ToggleButton === void 0 ? SimpleToggleButton : _ref2$ToggleButton,
      ValuePrefix = _ref2.ValuePrefix;
  var s = useStyles(defaultStyles);
  var token = useToken();
  var referenceEl = useRef(null);

  var _useState = useState(DEFAULT_MAX_HEIGHT),
      _useState2 = _slicedToArray(_useState, 2),
      maxHeight = _useState2[0],
      setMaxHeight = _useState2[1];

  var applyMaxSize = useMemo(function () {
    return {
      name: 'applyMaxSize',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['maxSize'],
      fn: function fn(_ref3) {
        var _context;

        var state = _ref3.state;
        var height = state.modifiersData.maxSize.height;
        state.styles.popper.maxHeight = _concatInstanceProperty(_context = "clamp(150px, ".concat(height, "px, ")).call(_context, maxHeight, "px)");
      }
    };
  }, [maxHeight]);

  var _useSelect = useSelect(),
      id = _useSelect.id,
      isOpen = _useSelect.isOpen,
      items = _useSelect.items,
      highlightedIndex = _useSelect.highlightedIndex,
      selectItem = _useSelect.selectItem,
      getToggleButtonProps = _useSelect.getToggleButtonProps,
      getComboboxProps = _useSelect.getComboboxProps,
      getMenuProps = _useSelect.getMenuProps; // Force downshift to stop showing an error


  getComboboxProps();
  getMenuProps();
  var toggleButtonHeight = (_referenceEl$current$ = referenceEl === null || referenceEl === void 0 ? void 0 : (_referenceEl$current = referenceEl.current) === null || _referenceEl$current === void 0 ? void 0 : _referenceEl$current.offsetHeight) !== null && _referenceEl$current$ !== void 0 ? _referenceEl$current$ : 0;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      maxWidth: token('select.breakpoint', 's')
    }
  }, /*#__PURE__*/React.createElement(ToggleButton, _extends({}, getToggleButtonProps({
    ref: referenceEl,
    tabIndex: 0,
    disabled: disabled,
    placeholder: placeholder,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Tab') {
        if (highlightedIndex > -1) {
          selectItem(items[highlightedIndex]);
        }
      }
    }
  }), {
    meta: meta,
    "data-testid": "select.toggle-button.".concat(id),
    Prefix: ValuePrefix
  })), !disabled && /*#__PURE__*/React.createElement(SelectOverlay, {
    portalTarget: portalTarget
  }, /*#__PURE__*/React.createElement(Menu, {
    helperText: helperText,
    placeholder: placeholder,
    Option: Option,
    Prefix: ValuePrefix
  }))), /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      minWidth: token('select.breakpoint', 's')
    }
  }, /*#__PURE__*/React.createElement(Tether, {
    disabled: disabled,
    distance: 0,
    modifiers: [{
      name: 'offset',
      enabled: true,
      options: {
        offset: [0, toggleButtonHeight * -1]
      }
    }, {
      name: 'preventOverflow',
      enabled: true,
      options: {
        padding: 0
      }
    }, _objectSpread(_objectSpread({}, maxSize), {}, {
      options: {
        padding: 12
      }
    }), applyMaxSize]
  }, function (_ref4) {
    var _referenceEl$current2;

    var referenceProps = _ref4.referenceProps,
        popperProps = _ref4.popperProps,
        placement = _ref4.placement;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleButton, _extends({}, getToggleButtonProps({
      ref: mergeRefs([referenceProps.ref, referenceEl]),
      tabIndex: 0,
      disabled: disabled,
      placeholder: placeholder,
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Tab') {
          if (highlightedIndex > -1) {
            selectItem(items[highlightedIndex]);
          }
        }
      }
    }), {
      meta: meta,
      "data-testid": "select.toggle-button.".concat(id),
      Prefix: ValuePrefix
    })), /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(TransitionSingle, {
      show: isOpen,
      configs: [{
        from: {
          height: toggleButtonHeight,
          opacity: 0
        },
        enter: function enter() {
          return /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(next, ref) {
              var node, menuHeight;
              return _regeneratorRuntime.wrap(function _callee$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      // TODO: Transition config isn't typed properly
                      node = ref;
                      menuHeight = 0;

                      if (node) {
                        node.style.height = 'auto';
                        menuHeight = node === null || node === void 0 ? void 0 : node.offsetHeight;
                        node.style.height = '';
                      }

                      _context2.next = 5;
                      return next({
                        opacity: 1,
                        config: {
                          duration: 80
                        }
                      });

                    case 5:
                      _context2.next = 7;
                      return next({
                        height: menuHeight
                      });

                    case 7:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x, _x2) {
              return _ref5.apply(this, arguments);
            };
          }();
        },
        update: function update() {
          return /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(next, ref) {
              var node, menuHeight;
              return _regeneratorRuntime.wrap(function _callee2$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      // TODO: Transition config isn't typed properly
                      node = ref;
                      menuHeight = 0;

                      if (node) {
                        node.style.height = 'auto';
                        menuHeight = node === null || node === void 0 ? void 0 : node.offsetHeight;
                        node.style.height = '';
                      }

                      _context3.next = 5;
                      return next({
                        height: menuHeight
                      });

                    case 5:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x3, _x4) {
              return _ref6.apply(this, arguments);
            };
          }();
        },
        leave: [{
          height: toggleButtonHeight
        }, {
          opacity: 0,
          config: {
            duration: 80
          }
        }],
        config: {
          mass: 0.8,
          tension: 700,
          friction: 52,
          clamp: true
        }
      }]
    }, /*#__PURE__*/React.createElement(Box, _extends({}, popperProps, s.with('popper')({
      style: popperProps.style,
      className: popperProps.className,
      width: referenceEl === null || referenceEl === void 0 ? void 0 : (_referenceEl$current2 = referenceEl.current) === null || _referenceEl$current2 === void 0 ? void 0 : _referenceEl$current2.offsetWidth
    }), {
      ref: popperProps.ref,
      flexDirection: "column"
    }), /*#__PURE__*/React.createElement(Menu, {
      helperText: helperText,
      placeholder: placeholder,
      placement: placement,
      toggleButtonEl: referenceEl.current,
      setMaxHeight: setMaxHeight,
      Option: Option,
      Prefix: ValuePrefix
    }))), portalTarget));
  })));
}
export function Select(_ref7) {
  var propId = _ref7.id,
      children = _ref7.children,
      props = _objectWithoutProperties(_ref7, _excluded);

  var id = useRef(propId !== null && propId !== void 0 ? propId : null);

  function getId() {
    if (id.current === null) {
      id.current = uuid();
    }

    return id.current;
  }

  return /*#__PURE__*/React.createElement(SelectProvider, _extends({}, props, {
    id: getId()
  }), /*#__PURE__*/React.createElement(SelectInner, props));
}